module.exports = __webpack_public_path__ + "img/more left.e6c4b9bd.svg";